/**
 * API权限守卫
 * 实现请求拦截器中的权限检查机制
 */

import { message } from 'antd';
import type { RequestOptionsInit } from 'umi-request';
import { apiPermissionConfigManager } from '@/config/apiPermissionConfig';

// 从全局状态获取权限数据
let globalUserPermissions: string[] = [];

// 更新全局权限数据的方法
export const updateGlobalPermissions = (permissions: string[]) => {
  globalUserPermissions = permissions;
};

/**
 * 请求拦截器 - 权限检查
 */
export const permissionInterceptor = async (
  _url: string,
  options: RequestOptionsInit,
): Promise<RequestOptionsInit> => {
  // 检查是否启用后端权限模式
  if (!apiPermissionConfigManager.shouldCheckPermission()) {
    // 本地路由模式，跳过权限检查
    return options;
  }

  // 使用全局权限数据
  const _userPermissions = globalUserPermissions;

  // 简单的权限检查逻辑
  // TODO: 根据实际需求添加具体的权限检查规则
  // 目前只是简单地记录日志

  return options;
};

/**
 * 响应拦截器 - 权限相关错误处理
 */
export const permissionResponseInterceptor = async (
  response: Response,
  _options: RequestOptionsInit,
): Promise<Response> => {
  // 处理 403 权限拒绝响应
  if (response.status === 403) {
    const responseData = await response
      .clone()
      .json()
      .catch(() => ({}));

    if (responseData?.code === 'PERMISSION_DENIED') {
      message.error(responseData?.message || '您没有执行此操作的权限');
    }
  }

  return response;
};

/**
 * 权限守卫 Hook
 */
export const useApiPermissionGuard = () => {
  const checkPermission = (url: string, options: RequestOptionsInit) => {
    const allowed = apiPermissionConfigManager.shouldCheckPermission();
    return {
      allowed,
      details: {
        url,
        method: options.method,
        mode: allowed ? '后端权限模式' : '本地路由模式',
      },
    };
  };

  return {
    checkPermission,
  };
};
